import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectSubscriptionList } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { compareSubscriptionList } from 'helpers/compareSubscriptionList'

import { setSelectedSubscriptionAction } from '../redux/actions/common'

export const useDefaultSubscription = () => {
  const dispatch: TAppDispatch = useDispatch()
  const subscriptions = useSelector(
    selectSubscriptionList,
    compareSubscriptionList,
  )

  useEffect(() => {
    const defaultSubscription =
      subscriptions.find(({ isDefault }) => isDefault) || subscriptions[0]

    defaultSubscription &&
      dispatch(setSelectedSubscriptionAction(defaultSubscription))
  }, [dispatch, subscriptions])
}
